var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentMethodVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 24,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0503 15.8486H8.99052L7.44596 9.78271C7.37265 9.50368 7.21699 9.257 6.98802 9.14073C6.41659 8.84856 5.78692 8.61604 5.10001 8.49876V8.26523H8.41809C8.87603 8.26523 9.21949 8.61604 9.27673 9.02346L10.0781 13.399L12.1369 8.26523H14.1394L11.0503 15.8486ZM15.2842 15.8486H13.339L14.9408 8.26523H16.886L15.2842 15.8486ZM19.4027 10.366C19.46 9.95761 19.8034 9.72407 20.2041 9.72407C20.8338 9.66544 21.5197 9.78271 22.0921 10.0739L22.4356 8.44114C21.8631 8.20761 21.2335 8.09033 20.6621 8.09033C18.774 8.09033 17.4002 9.14074 17.4002 10.5986C17.4002 11.7076 18.3733 12.2899 19.0603 12.6407C19.8034 12.9905 20.0896 13.2241 20.0324 13.5739C20.0324 14.0986 19.46 14.3321 18.8885 14.3321C18.2016 14.3321 17.5147 14.1572 16.886 13.865L16.5426 15.4988C17.2295 15.7899 17.9726 15.9072 18.6596 15.9072C20.7765 15.9648 22.0921 14.9155 22.0921 13.3403C22.0921 11.3568 19.4027 11.2405 19.4027 10.366ZM28.9 15.8486L27.3555 8.26523H25.6964C25.353 8.26523 25.0095 8.49876 24.895 8.84856L22.0349 15.8486H24.0374L24.4371 14.7405H26.8975L27.1265 15.8486H28.9ZM25.9826 10.3074L26.5541 13.1655H24.9523L25.9826 10.3074Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethodVisa);
export default __webpack_public_path__ + "static/media/payment-method-visa.1e6d857d097bc7ed4f58870e0c278ad7.svg";
export { ForwardRef as ReactComponent };